// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AutoCompleteResults-cls1__c08e4d272629d916250c{/*!*/}.AutoCompleteResults-cls2__cf02c53e881270acb84b{display:flex;width:100%;justify-content:center;align-items:center;flex-direction:row;padding:12px 0px;border-top:1px solid rgba(0,0,0,.15)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AutoCompleteResults-cls1__c08e4d272629d916250c",
	"cls2": "AutoCompleteResults-cls2__cf02c53e881270acb84b AutoCompleteResults-cls1__c08e4d272629d916250c"
};
export default ___CSS_LOADER_EXPORT___;
